"use client";

import { usePathname } from "next/navigation";

import { ChevronRightCircle } from "lucide-react";

import { Button } from "@repo/ui/components/ui/button";
import { Link } from "@repo/ui/navigation";

import { useAppSelector } from "@repo/store/hooks";
import { selectIsCheckIn } from "@repo/store/slices";

type Props = {
  text?: string;
  /** When set, the button navigates to this URL (e.g. /signup). */
  signupHref?: string;
};

export default function RegisterButton({ text = "Sign Up", signupHref }: Props) {
  const pathname = usePathname();
  const isCheckin = useAppSelector(selectIsCheckIn);

  if (!isCheckin && !pathname.includes("/passengers")) {
    return null;
  }

  const buttonContent = (
    <>
      {text}
      <ChevronRightCircle />
    </>
  );

  if (signupHref) {
    return (
      <Link href={signupHref} data-testid="register-signup-link">
        <Button
          className="border border-brand-blue bg-white text-brand-blue hover:bg-brand-red cursor-pointer rounded-full min-w-[128px] hover:bg-brand-blue hover:text-white"
          data-testid="register-signup-btn"
        >
          {buttonContent}
        </Button>
      </Link>
    );
  }

  return (
    <Button
      className="border border-brand-blue bg-white text-brand-blue hover:bg-brand-red cursor-pointer rounded-full min-w-[128px] hover:bg-brand-blue hover:text-white"
      data-testid="register-signup-btn"
    >
      {buttonContent}
    </Button>
  );
}
